;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');
	var checkboxFieldTemplate = JST.Checkbox;

	Model.User = Model.User.extend({
		constructor: function(){
			this.validations = new Model.Validations();
			this.setSchemaValidation();
			Backbone.Model.apply(this, arguments);
		},
		setSchemaValidation: function(){
			this.schema = _.mapObject(this.schema, _.bind(function(value ,key){
				value.validators = this.validations.getValidationItems( value.validators ).length ? this.validations.getValidationItems( value.validators ): value.validators;
				return value;
			}, this));
		},
		defaults: {
			first_name: '',
			last_name: '',
			email: '',
			password: '',
			team_name: '',
			country: '',
			state: '',
			postcode: '',
			birthday: null,
			mobile: '',
			team_supported: 0,
			games_attend: 'none',
			watch_tv: '',
			avatar: {},
			news: 1,
			facebook_id: '',
			twitter_id: '',
			recovered: '',
			id: ''
		},
		schema: {
			first_name:{
				title: 'First name',
				editorClass: 'first_name',
				editorAttrs: {
					maxlength: 45,
					placeholder: 'Enter First Name'
				},
				validators: ['first_name_regexp']
			},
			last_name:{
				title: 'Last name',
				editorClass: 'last_name',
				editorAttrs: {
					maxlength: 45,
					placeholder: 'Enter Last Name'
				},
				validators: ['last_name_regexp']
			},
			email:{
				title: 'Email Address',
				editorClass: 'email',
				editorAttrs: {
					placeholder: 'name@email.com',
					title: 'Your email will be used as your username when you log in'
				},
				validators: ['email_validation']
			},
			confirm_email:{
				title: 'Confirm Email Address*',
				editorClass: 'confirm_email',
				editorAttrs: {
					placeholder: 'name@email.com'
				},
				validators: ['email_validation','email_match']
			},
			password:{
				title: 'Password',
				type: 'Password',
				editorClass: 'password',
				editorAttrs: {
					minlength: 8,
					placeholder: 'Enter Password'
				},
				validators: ['password_regexp']
			},
			passwordConfirm:{
				title: 'Confirm Password*',
				type: 'Password',
				editorClass: 'passwordConfirm',
				editorAttrs: {
					placeholder: 'Enter Password'
				},
				validators:['passwordConfirm_regexp', 'password_match']
			},
			country: {
				type: 'Select',
				editorClass: 'country',
				title: 'Country',
				options: function(callback, editor) {
					if(editor.form.data){
						callback( _.map(editor.form.data.countryList , function(value){
							return {
								val: value.code,
								label: value.name
							}
						}));
					}
				},
				validators: []
			},
			state: {
				type: 'Select',
				editorClass: 'state',
				title: 'State',
				options: function(callback, editor) {
					if(editor.form.data){
						callback( _.map(editor.form.data.statesList , function(value){
							return {
								val: value.id,
								label: value.state
							}
						}));
					}
				},
				validators: ['state_required']
			},
			postcode: {
				title: 'Postcode:',
				editorClass: 'postcode',
				editorAttrs: {
					maxlength: 45,
					placeholder: 'Postcode:'
				},
				validators: ['postcode_check_country', 'postcode_length', 'postcode_is_number']
			},
			birthday: {
				title: 'Date of Birth',
				editorClass: 'birthday',
				type: 'Date',
				yearStart: 2017,
				yearEnd: 1936,
				validators: []
			},
			mobile: {
				title: 'Mobile Number',
				editorClass: 'mobile',
				editorAttrs: {
					maxlength: 15,
					minlength: 9,
					placeholder: 'Enter Mobile Number'
				},
				validators: ['mobile_is_number', 'mobile_length']
			},
			team_name:{
				title: 'Team name:',
				editorAttrs: {
					maxlength: 40,
					placeholder: 'Enter Team Name'
				},
				validators:  ['team_name_required', 'team_name_regexp']
			},
			team_supported: {
				title: 'Team Supported',
				editorClass: 'team_supported',
				type: 'Select',
				options: function(callback, editor) {
					if(editor.form.data){
						callback(_.map(editor.form.data.squads , function(value){
							return {
								val: value.id,
								label: value.name
							}
						}));
					}
				},
				validators: []
			},
			games_attend: {
				type: 'Select',
				editorClass: 'games_attend',
				title: 'How many games do you attend per season?',
				options: ['1-2', '3-6', '7+', 'none']
			},
			watch_tv: {
				type: 'Select',
				editorClass: 'games_attend',
				title: 'How often do you watch AFL on TV?',
				options: [
					{val: 'regularly', label: 'Regularly (at least once per week)'},
					{val: 'often', label: 'Often (every 2-3 weeks)'},
					{val: 'rarely', label: 'Rarely or never'}
				]
			},
			disable_notifications: {
				type: 'OnOFFCheckbox',
				title: 'Receive all notifications',
				options:{},
				template: checkboxFieldTemplate,
				changeEl : function(el){

					var checkbox = $( el ).find('input');

					if( checkbox.is( ":checked" )){
						checkbox.prop("checked", false);
					}
					else {
						checkbox.prop("checked", true);
					}

				}
			},
			weekly_results: {
				type: 'OnOFFCheckbox',
				title: 'Weekly Results Update',
				options:{},
				template: checkboxFieldTemplate
			},
			weekly_reminders: {
				type: 'OnOFFCheckbox',
				title: 'Weekly Reminder',
				options:{},
				template: checkboxFieldTemplate
			},
			news: {
				type: 'OnOFFCheckbox',
				title: 'I agree to receiving direct communications from AFL',
				options:{},
				template: checkboxFieldTemplate,
				validators: []
			},
			avatar: {
				type: "ImagePicker",
				button_text: 'Add Picture',
				user_img_url: CONFIG.IMAGES_URL+'nouserpic.png',
				template: JST.ImageUploader
			}
		}
	});

}(window, APP, Backbone, Marionette, $, _));
